module.exports = __webpack_public_path__ + "static/media/virus.e62d3a43.svg";